import { store } from "common/store";

export const getAPI = function(addVersion = false) {
    const state = store.getState();
    
    if (!state.common.user.superuser && !state.config.debug) return false;
    
    const apiEnvs = {
        "api.stg1.pazien.com": "stg1",
        "api.pazien.com": "Production"
    };
    
    const apiHost = state.config.api_host;
    const apiVersion = state.config.api_version;
    
    let match;
    
    try {
        match = Object.entries(apiEnvs).find(([key, val]) => apiHost.indexOf(key) > 0);
    } catch {
        // Swallow the error.
    }
    
    if (match && addVersion) {
        return `${match[1]} (${apiVersion.replace("merchant_api ", "")})`;
    }
    
    if (match && match[1]) {
        return match[1];
    }
    
    return "Unknown";
};
